export var getRowProps = function getRowProps(_ref) {
  var errors = _ref.errors,
    columns = _ref.columns,
    getTdProps = _ref.getTdProps,
    onAction = _ref.onAction,
    rowStyle = _ref.rowStyle,
    highlightRowOnFocus = _ref.highlightRowOnFocus,
    data = _ref.data,
    setRowHeight = _ref.setRowHeight;
  return {
    errors: errors,
    columns: columns,
    getTdProps: getTdProps,
    onAction: onAction,
    rowStyle: rowStyle,
    highlightRowOnFocus: highlightRowOnFocus,
    list: data,
    setRowHeight: setRowHeight
  };
};
export var getInnerElementTypeProps = function getInnerElementTypeProps(_ref2) {
  var columns = _ref2.columns,
    onAction = _ref2.onAction,
    sortDetails = _ref2.sortDetails,
    headerClassName = _ref2.headerClassName,
    data = _ref2.data,
    loading = _ref2.loading;
  return {
    columns: columns,
    onAction: onAction,
    sortDetails: sortDetails,
    headerClassName: headerClassName,
    data: data,
    loading: loading
  };
};